import { AgentsActions } from "redux/actions/agentsActions";

const initialState = {
    data: [],
    error: null,
    isLoading: false,
};

const agentsReducer = (state = initialState, action) => {
    switch (action.type) {
        case AgentsActions.SET_DATA:
            return {
                ...state,
                data: action.payload,
            };
        default:
            return state;
    }
};

export default agentsReducer;